import { CSSObject } from "@emotion/react";
import { Link } from "react-router-dom";
import { useAuth } from "src/components/pages";
import { Colors, Icon } from "swing-components";

import { createMyDocumentsUrl } from "~pages";
import { msg } from "~utils";

export function ExpiringDocumentsBanner() {
  const {
    userInfo: { isAlias },
  } = useAuth();

  return (
    <div
      role="status"
      css={
        {
          backgroundColor: Colors.red500,
          color: Colors.white200,
          display: "flex",
          gap: 8,
          paddingTop: isAlias ? 4 : "calc(var(--ion-safe-area-top, 0px) + 4px)",
          paddingRight: 8,
          paddingBottom: 4,
          paddingLeft: 8,
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          // Display under AliasBanner if user is aliased
          // 29px comes from height + padding of AliasBanner
          top: isAlias ? "calc(var(--ion-safe-area-top, 0px) + 29px)" : 0,
          left: 0,
          right: 0,
          zIndex: 6,

          "@media (min-width: 900px)": {
            padding: 8,
          },
        } as CSSObject
      }
    >
      <Icon name="Alert" color={Colors.white200} />
      <div>
        {msg("EXPIRING_DOCUMENTS_LINK_LABEL_PREFIX")}{" "}
        <Link to={createMyDocumentsUrl()} css={{ color: Colors.white200 }}>
          {msg("EXPIRING_DOCUMENTS_LINK_LABEL")}
        </Link>
      </div>
    </div>
  );
}
